"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const internal_1 = require("@adsk/exo-skeleton-api/internal");
const const_1 = require("../const");
function waitForExoRemotesListToLoad() {
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            reject(new Error('[ ExoSkeletonRuntimePlugin: "setRemoteUrlFromPlaceholder" ] Timed out waiting for remotes list to load'));
        }, 5000);
        // Listen for the remotes list event
        window.addEventListener(internal_1.EXO_SKELETON_EVENT_NAMES.REMOTES_LIST_FETCHED, () => {
            clearTimeout(timeoutId);
            resolve(null);
        }, { once: true });
    });
}
const runtimePlugin = () => {
    return {
        name: 'setRemoteUrlFromPlaceholder',
        beforeRequest: async (args) => {
            if (!window.ExoSkeletonRuntime) {
                await waitForExoRemotesListToLoad();
            }
            for (const remote of args.options.remotes) {
                const remoteDetails = window.ExoSkeletonRuntime.remotes[remote.name];
                if (remoteDetails &&
                    remote?.entry.includes(const_1.EXO_SKELETON_PLACEHOLDER)) {
                    remote.entry =
                        remoteDetails.url;
                }
            }
            return args;
        },
    };
};
exports.default = runtimePlugin;
//# sourceMappingURL=setRemoteUrlFromPlaceholder.js.map